/* still mode (screenshot / reduced-motion) — reveal everything, no scroll animation */
if(location.search.includes('still')||matchMedia('(prefers-reduced-motion:reduce)').matches){document.documentElement.classList.add('still')}
if(location.search.includes('brute')){document.documentElement.classList.add('show-brute')}
/* screenshot band offset: ?y=N shifts page up N px so headless can capture lower bands legibly */
var _Y=new URLSearchParams(location.search).get('y'); if(_Y){document.body.style.transform='translateY(-'+_Y+'px)'}

/* nav scroll shadow */
addEventListener('scroll',()=>document.getElementById('nav').classList.toggle('scrolled',scrollY>36),{passive:true});

/* scroll-triggered entrance animations removed 2026-07-02 (Tian: 不要滚动特效) — .rv statically visible via CSS, stat values static in markup */

/* manifeste 3 chemins tabs */
document.querySelectorAll('.chemin-tab').forEach(tab=>tab.addEventListener('click',()=>{
  document.querySelectorAll('.chemin-tab').forEach(t=>t.setAttribute('aria-selected','false'));
  document.querySelectorAll('.chemin-panel').forEach(p=>p.classList.remove('active'));
  tab.setAttribute('aria-selected','true');
  document.querySelector('.chemin-panel[data-panel="'+tab.dataset.tab+'"]').classList.add('active');
}));

/* FAQ accordion */
document.querySelectorAll('.faq-q').forEach(btn=>btn.addEventListener('click',()=>{
  const item=btn.closest('.faq-item'),wasOpen=item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(i=>i.classList.remove('open'));
  if(!wasOpen)item.classList.add('open');
}));